import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import * as classnames from 'classnames';
import { OkIcon } from '@estee/elc-icons';
import { Body2, Subtitle2 } from '@estee/elc-typography';
import { Button } from '@estee/elc-buttons';

export interface IProductNotifyMeConfirmationContent {
    content: string;
    contentTitle: string;
    onContinueShoppingButtonClick(): void;
    continueShoppingButtonLabel?: string;
}

const NotifyMeConfirmationContent = styled.div`
    margin: 0 auto;
    padding: 110px 50px;
    max-width: 350px;
    text-align: center;
`;

const StyledIcon = styled.div`
    width: 45px;
    margin: 0 auto;
    fill: #000 40%;
`;

const ContentText = styled(Body2)`
    line-height: 25px;
`;

const ContentTitle = styled(Subtitle2)`
    margin: 15px;
`;

const ContinueButton = styled(Button)`
    border: none;
    outline: none;
    border-radius: 0;
    position: absolute;
    bottom: 0;
    cursor: pointer;
    padding: 0 10px;
`;

export const ProductNotifyMeConfirmationContent = observer(
    (props: IProductNotifyMeConfirmationContent) => {
        const productNotifyMeConfirmationContentClassNames = classnames(
            'elc-product-notify-me-confirmation-content',
            'js-product-notify-me-confirmation-content'
        );

        const productNotifyMeConfirmationIconClassNames = classnames(
            'elc-product-notify-me-confirmation-icon',
            'js-product-notify-me-confirmation-icon'
        );

        const productNotifyMeConfirmationTitleClassNames = classnames(
            'elc-product-notify-me-confirmation-title',
            'js-product-notify-me-confirmation-title'
        );

        const productNotifyMeConfirmationContinueButtonClassNames = classnames(
            'elc-product-notify-me-confirmation-continue-button',
            'js-product-notify-me-confirmation-continue-button'
        );

        const productNotifyMeConfirmationContentTextClassNames = classnames(
            'elc-product-notify-me-confirmation-content-text',
            'js-product-notify-me-confirmation-content-text'
        );

        const { continueShoppingButtonLabel } = props;

        return (
            <NotifyMeConfirmationContent className={productNotifyMeConfirmationContentClassNames}>
                <StyledIcon>
                    <OkIcon className={productNotifyMeConfirmationIconClassNames} />
                </StyledIcon>
                <ContentTitle className={productNotifyMeConfirmationTitleClassNames}>
                    {props.contentTitle}
                </ContentTitle>
                <ContentText
                    className={productNotifyMeConfirmationContentTextClassNames}
                    dangerouslySetInnerHTML={{ __html: props.content }}
                />
                <ContinueButton
                    className={productNotifyMeConfirmationContinueButtonClassNames}
                    onClick={props.onContinueShoppingButtonClick}
                >
                    {continueShoppingButtonLabel}
                </ContinueButton>
            </NotifyMeConfirmationContent>
        );
    }
);
